// Config loaded from environment or hardcoded after deploy
const config = {
  apiUrl: process.env.REACT_APP_API_URL || '',
  userPoolId: process.env.REACT_APP_USER_POOL_ID || '',
  clientId: process.env.REACT_APP_CLIENT_ID || '',
  region: 'us-east-1',
};

export default config;
